var map = {
	"./m-agenda.svg": 570,
	"./m-b2b.svg": 571,
	"./m-claims.svg": 572,
	"./m-clients.svg": 573,
	"./m-dsdocuments.svg": 574,
	"./m-faq.svg": 575,
	"./m-generali.svg": 576,
	"./m-inbox-blue.svg": 577,
	"./m-inbox.svg": 578,
	"./m-links.svg": 579,
	"./m-logout.svg": 359,
	"./m-news.svg": 580,
	"./m-office.svg": 581,
	"./m-outbox.svg": 582,
	"./m-production.svg": 583,
	"./m-tasklist.svg": 584,
	"./m-webapps.svg": 585,
	"./m-willdoc.svg": 586
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 592;



//////////////////
// WEBPACK FOOTER
// ./resources/images ^\.\/m\-.*\.svg$
// module id = 592
// module chunks = 0